import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Tab, Typography } from '@mui/material';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import PropTypes from 'prop-types';

import { PendingChangesActionType } from 'constants/pendingChanges';

import { tabLabelStyles, tabLabelWrapper, tabStyles } from './FinancialInfoHead.styles';

const NavigationTab = ({
  value,
  icon,
  label,
  to,
  isSelected,
  isModified,
  pendingChangeAuthors = null,
}) => (
  <Tab
    disableRipple
    aria-selected={isSelected}
    component={Link}
    label={
      <Box sx={tabLabelWrapper}>
        {icon}

        <PendingChangeWrapper
          isSmall
          authors={pendingChangeAuthors}
          fieldLabel={label}
          pendingChangesActionType={isModified ? PendingChangesActionType.MODIFIED : undefined}
        >
          <Box>
            <Typography className="label" sx={tabLabelStyles} variant="regular14">
              {label}
            </Typography>
            <Typography className="hidden-label" sx={tabLabelStyles} variant="regular14">
              {label}
            </Typography>
          </Box>
        </PendingChangeWrapper>
      </Box>
    }
    sx={tabStyles}
    to={to}
    value={value}
  />
);

NavigationTab.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isModified: PropTypes.bool.isRequired,
  pendingChangeAuthors: PropTypes.arrayOf(PropTypes.object),
};

export default NavigationTab;
